import { fromDate14DaysEarlier, toDateToday } from 'charts/common';
import { AnalyticsTranslationKeys, CommonTranslationKeys, InspectionTranslationKeys } from 'intl/keys';
import { FilterValues } from 'shared/types/analytics';

export function defaultValues(): FilterValues {
  return {
    dataScope: {
      labelId: AnalyticsTranslationKeys.tab,
      filters: [
        {
          labelId: AnalyticsTranslationKeys.dateRange,
          value: {
            from: fromDate14DaysEarlier,
            to: toDateToday,
          },
        },
        {
          labelId: CommonTranslationKeys.process,
          value: [],
        },
        {
          labelId: AnalyticsTranslationKeys.sites,
          value: [],
        },
        {
          labelId: InspectionTranslationKeys.tableAuthor,
          value: [],
        },
      ],
    },
  };
}
